const GetChargeTypes = {
    GET_CHARGE_TYPES : 'GET_CHARGE_TYPES'
}

export default GetChargeTypes